import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');
	const sphere = geo.createNode('sphere');
	sphere.p.type.set(1);

	// add a light
	root.createNode('hemisphereLight');

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [sphere],
		autoLayout: true,
	};
}
// export const sopSphereIcosahedron = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/sop/sphere/icosahedron`,
// 		createData,
// 		relatedNodes: [SphereSopNode],
// 	}),
// ];
